import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const dataTabEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() => import(/* webpackChunkName: "async-data-tab" */ './index')),
	getPreloadProps: () => ({
		extraProps: {},
	}),
});
